import { render, staticRenderFns } from "./CockpitBackdrop.vue?vue&type=template&id=5770aa3a&scoped=true"
import script from "./CockpitBackdrop.vue?vue&type=script&lang=js"
export * from "./CockpitBackdrop.vue?vue&type=script&lang=js"
import style0 from "./CockpitBackdrop.vue?vue&type=style&index=0&id=5770aa3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5770aa3a",
  null
  
)

export default component.exports